import React from 'react';

import Styles from './styles.module.scss';
import LineChartPlaceholder from './LineChartPlaceHolder';

interface IProps {
    text: string;
}

const LineChartNoData = (props: IProps) => {
    return (
        <div className={Styles.NoData}>
            <div className={Styles.NoDataContent}>
                <LineChartPlaceholder />
                <p className={Styles.NoDataText}>{props.text}</p>
            </div>
        </div>
    );
};

export default LineChartNoData;
